import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProdutoEspecialVendedor } from '../../core/models/produtos/produto-especial-vendedor';

@Component({
    selector: 'app-tabela-vendedores-editavel',
    templateUrl: './tabela-vendedores-editavel.component.html',
    styleUrls: ['./tabela-vendedores-editavel.component.css'],
    standalone: false
})
export class TabelaVendedoresEditavelComponent implements OnInit {
  @Input() vendedores: ProdutoEspecialVendedor[] = [];
  @Output() vendedoresChange = new EventEmitter<ProdutoEspecialVendedor[]>();

  /* Edição Inline */
  editandoCelula: { index: number; campo: string } = null;
  valorOriginal: any = null;

  /* Edição em Massa */
  vendedoresSelecionados: Set<number> = new Set();
  todosSelecionados: boolean = false;

  edicaoEmMassa = {
  };

  /* Console para Debug */
  console = console;

  constructor(private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  /* ===== EDIÇÃO INLINE ===== */

  iniciarEdicao(index: number, campo: string) {
    this.editandoCelula = { index, campo };
    this.valorOriginal = this.vendedores[index][campo];
  }

  finalizarEdicao(index: number, campo: string) {
    if (this.editandoCelula && this.editandoCelula.index === index && this.editandoCelula.campo === campo) {
      this.toastr.success("Alteração salva!", "Sucesso");
      this.editandoCelula = null;
      this.valorOriginal = null;
    }
  }

  cancelarEdicao(index: number) {
    if (this.editandoCelula && this.editandoCelula.index === index) {
      this.vendedores[index][this.editandoCelula.campo] = this.valorOriginal;
      this.editandoCelula = null;
      this.valorOriginal = null;
    }
  }

  estaEditando(index: number, campo: string): boolean {
    return this.editandoCelula != null && this.editandoCelula.index === index && this.editandoCelula.campo === campo;
  }

  /* ===== EDIÇÃO EM MASSA ===== */

  selecionarVendedor(idVendedorSelecionado: number) {
    if (this.vendedoresSelecionados.has(idVendedorSelecionado)) {
      this.vendedoresSelecionados.delete(idVendedorSelecionado);
    } else {
      this.vendedoresSelecionados.add(idVendedorSelecionado);
    }
    this.atualizarCheckboxTodosSelecionados();
  }

  estaVendedorSelecionado(idVendedorSelecionado: number): boolean {
    return this.vendedoresSelecionados.has(idVendedorSelecionado);
  }

  selecionarTodos() {
    if (this.todosSelecionados) {
      this.vendedoresSelecionados.clear();
      this.todosSelecionados = false;
    } else {
      this.vendedoresSelecionados.clear();
      for (let vendedor of this.vendedores) {
        this.vendedoresSelecionados.add(vendedor.idvendedor);
      }
      this.todosSelecionados = true;
    }
  }

  atualizarCheckboxTodosSelecionados() {
    this.todosSelecionados = this.vendedoresSelecionados.size === this.vendedores.length && this.vendedores.length > 0;
  }

  aplicarEdicaoEmMassa() {
    if (this.vendedoresSelecionados.size === 0) {
      this.toastr.info("Selecione pelo menos um vendedor(a)!", "Informação");
      return;
    }

    this.toastr.success(`${this.vendedoresSelecionados.size} vendedor(a)(s) selecionado(a)(s)!`, "Sucesso");
    this.limparEdicaoEmMassa();
  }

  limparEdicaoEmMassa() {
    this.edicaoEmMassa = {
    };
    this.vendedoresSelecionados.clear();
    this.todosSelecionados = false;
  }

  removerVendedorEmMassa() {
    if (this.vendedoresSelecionados.size === 0) {
      this.toastr.info("Selecione pelo menos um vendedor(a)!", "Informação");
      return;
    }

    const quantidadeRemovida = this.vendedoresSelecionados.size;

    this.vendedores = this.vendedores.filter(vendedor =>
      !this.vendedoresSelecionados.has(vendedor.idvendedor)
    );

    this.vendedoresSelecionados.clear();
    this.todosSelecionados = false;

    this.vendedoresChange.emit(this.vendedores);

    this.toastr.success(`${quantidadeRemovida} vendedor(a)(s) removido(s)!`, "Sucesso");
  }
}
